//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MapSection',
  data() {
    return {
      isOnline: true,
      venues: [],
    }
  },
  computed: {
    getMap() {
      const mapCode = this.$getTextMainSetting('yandexMapIframe')
      if (!mapCode.includes('loading="lazy"')) {
        return mapCode.replace(
          '<iframe ',
          '<iframe title="map" loading="lazy" '
        )
      }
      return mapCode
    },
  },
  mounted() {
    this.venues = this.$getVenues()
  },
  methods: {
    laptopPhoto() {
      const alternativeImage = this.$getBullets('locationSelectScreenLaptop')
      if (
        alternativeImage[0] !== undefined &&
        alternativeImage[0].url !== undefined &&
        alternativeImage[0].url.length > 0
      ) {
        return alternativeImage[0].url
      }

      return require('~/assets/img/partner/main/map-section/laptop.png')
    },
  },
}
